import type { Contact, Subject } from '@models';

export const resolveSelectedContact = (
  value: Subject,
  selectedContactId?: string
): Contact | null => {
  const contacts = value.contacts ?? [];
  const explicitlySelectedContact = contacts.find(
    (contact) => contact.id === selectedContactId
  );

  if (explicitlySelectedContact) {
    return explicitlySelectedContact;
  }

  return contacts.length === 1 ? contacts[0] : null;
};
